/* eslint-disable @typescript-eslint/no-unused-vars */
import {
	type IPublicClientApplication,
	type AccountInfo,
	PublicClientApplication,
} from "@azure/msal-browser"

export const scopes = [
 import.meta.env.VITE_AZURE_API_SCOPE
]

export const publicClientApplication = new PublicClientApplication({
	auth: {
		clientId: import.meta.env.VITE_AZURE_CLIENT_ID,
		authority: `https://login.microsoftonline.com/${import.meta.env.VITE_AZURE_TENANT_ID}`
	},
	cache: {
		cacheLocation: "localStorage"
	}
})

export const getTokenRedirect = async (pca: IPublicClientApplication, account: AccountInfo) => {
	try {
		return (await pca.acquireTokenSilent({ account, scopes })).accessToken
	} catch (error) {
		pca.acquireTokenRedirect({ scopes })
		throw new Error(redirectingErrorMessage)
	}
}

export const redirectingErrorMessage = "redirectingErrorMessage"
